import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { DeleteSequenceInstanceDTO } from 'crono-fe-common/types/DTO/deleteSequenceInstanceDTO';
import { useBackgroundInvalidateAutomatorDelay } from 'crono-fe-common/hooks/crono-extension/gateway';
import { invalidateTimelineQueries } from 'hooks/services/timeline/useSearchTimeline';

export default function useDeleteSequenceInstance() {
  const queryClient = useQueryClient();

  const deleteSequenceInstance = (data: DeleteSequenceInstanceDTO) => {
    const request: Request = {
      url: `${ENDPOINTS.strategy.prospectDelete}`,
      config: {
        method: 'delete',
        data: data,
      },
    };
    return client(request);
  };
  const { call: invalidateAutomatorDelay } =
    useBackgroundInvalidateAutomatorDelay();
  return useMutation<Response<null>, CronoError, DeleteSequenceInstanceDTO>(
    deleteSequenceInstance,
    {
      onSettled: (result, error, variables) => {
        invalidateAutomatorDelay({});
        queryClient.invalidateQueries([ENDPOINTS.account.search.main]);
        queryClient.invalidateQueries([ENDPOINTS.prospect.main]);
        queryClient.invalidateQueries({
          predicate: (query) =>
            query.queryKey
              .toString()
              .startsWith(ENDPOINTS.prospect.search.main),
        });
        queryClient.invalidateQueries([ENDPOINTS.task.search]);
        invalidateTimelineQueries(queryClient);
        queryClient.invalidateQueries([ENDPOINTS.task.main]);
        queryClient.invalidateQueries([ENDPOINTS.task.user.analytics]);
        queryClient.invalidateQueries([ENDPOINTS.task.aggregate]);
        queryClient.invalidateQueries([ENDPOINTS.task.total]);
        queryClient.invalidateQueries([ENDPOINTS.task.dailyQuantity]);
        queryClient.invalidateQueries([
          ENDPOINTS.task.linkedin.automatic.check,
        ]);
        queryClient.invalidateQueries([ENDPOINTS.task.linkedin.quantity]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.prospect]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
        queryClient.invalidateQueries([ENDPOINTS.signal.search]);
      },
    },
  );
}
